import XEUtils from 'xe-utils';
import { i18nConfigStore } from './i18nStore';
import { globalConfigStore } from './configStore';
export function getI18n(key, args) {
    const { langMaps, language } = i18nConfigStore;
    const { i18n } = globalConfigStore;
    if (i18n) {
        return `${i18n(key, args) || ''}`;
    }
    return XEUtils.toFormatString(XEUtils.get(langMaps[language], key, key), args);
}
export function hasLanguage(language) {
    const { langMaps } = i18nConfigStore;
    return !!langMaps[language];
}
export function getLanguage() {
    const { language } = i18nConfigStore;
    return language;
}
